import React, { PureComponent } from 'react';

import { I18n } from 'components/translate';
import { PropTypes } from 'prop-types';

import './InputGroup.scss';

export default class InputGroupCounter extends PureComponent {
  static propTypes = {
    length: PropTypes.number
  };

  static defaultProps = {
    length: 0
  };

  render() {
    const { length } = this.props;

    return (
      <p className="secondary characters__count">
        {length} <I18n html label="general.characters" />
      </p>
    );
  }
}
